/*
* 视频上传组件
*/
<template>
  <div>
    <van-uploader
            v-model="videoList"
            :max-count="limit"
            :accept="acceptType"
            :after-read="afterRead"
            :before-read="beforeRead"
            @click-preview="handleClick"
            :deletable="showUpload"
            :show-upload="showUpload"
    >
      <template slot="preview-cover">
        <video
                style="width:120px;height:120px;object-fit:cover;"
                :src="this.filePrefix + videoUrl"
                v-if="videoUrl"
        ></video>
      </template>
    </van-uploader>
    <!--        <div style="font-size:12px;color:#777">视频大小不能超过100M</div>-->
    <van-dialog
            style="width:100%;border-radius:0;height:200px"
            theme="default"
            v-model="showVideoPlay"
            :show-cancel-button="false"
            :show-confirm-button="false"
            closeOnClickOverlay
    >
      <video
              controls
              preload="auto"
              style="width:100%;height:200px;object-fit: contain;"
              :src="this.filePrefix + videoUrl"
              v-if="videoUrl"
      ></video>
    </van-dialog>
  </div>
</template>

<script>
  import {FILE_DISPLAY_PREFIX, customUploadFile} from '@/api/upload'

  export default {
    name: 'video-upload',
    props: {
      // 是否支持上传, 默认支持
      showUpload: {
        type: Boolean,
        default: true
      },
      value: {
        type: String,
        default: ''
      },
      //文件接受类型
      acceptType: {
        type: String,
        default: "video/*"
      },
      //
      limit: {
        type: Number,
        default: () => 5
      },
      //上传文件的小
      maxSize: {
        type: Number,
        default: () => 2048
      }
    },
    data() {
      return {
        videoList: [],
        videoUrl: "",
        showVideoPlay: false,
        filePrefix: FILE_DISPLAY_PREFIX
      }
    },
    watch: {
      value(val) {
        this.handleFileList(val)
      }
    },
    created() {
      this.handleFileList(this.value)
    },
    methods: {
      getUrls() {
        return this.videoList.map(i => i.path).join(",")
      },
      addFileList(path) {
        this.videoList.push({
          url: path,
          path: path
        })
      },
      handleFileList(str) {
        const paths = str ? str.split(',') : [];
        paths.forEach(path => {
          this.addFileList(path)
        })
      },
      onOversize(file) {
        this.$toast(`文件大小不能超过${this.maxSize}kb`);
      },
      //限制上传的内容为视频或图片
      beforeRead(file) {
        if (!file.type.startsWith('video')) {
          this.$toast('请上传视频');
          return false
        }
        return true
      },

      afterRead(file) {
        file.status = 'uploading';
        file.message = '上传中...';
        //添加上传状态，避免用户在上传未完成时点击提交按钮
        customUploadFile(file.file).then(res => {
          if (res.code === 10000) {
            // this.videoUrl = res.result[0];
            this.addFileList(res.result[0]);
            file.status = 'done';
          }
        }).catch(e => {
          file.status = 'failed';
          file.message = '上传失败';
          this.$toast('上传失败' + e)
        }).finally(() => {
          this.videoList = this.videoList.filter(i => i.path)
        });
      },
      handleClick(file) {
        this.videoUrl = file.path;
        this.showVideoPlay = true;
      }
    }
  }
</script>

<style scoped>
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .img-block {
    position: relative;
  }
  video{
    width: 100%;
    max-height: 90vh;
  }
</style>
